import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "transparent",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F3F3F3",
      d: "M13.5 13h-11l2-4V5.5l.5-1 1-1L8 3l2 .5 1.5 2V9l2 4Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#434242",
      d: "M7.99 16a2.503 2.503 0 0 1-2.5-2.5.5.5 0 0 1 1 0c0 .827.672 1.5 1.5 1.5.827 0 1.5-.673 1.5-1.5a.5.5 0 0 1 1 0c0 1.379-1.122 2.5-2.5 2.5Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#434242",
      d: "M13.49 14h-11a1.168 1.168 0 0 1-.759-2.053 4.468 4.468 0 0 0 1.592-3.422V6.667A4.672 4.672 0 0 1 7.99 2a4.672 4.672 0 0 1 4.667 4.667v1.858c0 1.32.578 2.565 1.585 3.417A1.167 1.167 0 0 1 13.49 14ZM7.99 3a3.67 3.67 0 0 0-3.667 3.667v1.858a5.464 5.464 0 0 1-1.94 4.18.166.166 0 0 0 .107.295h11c.09 0 .167-.076.167-.167a.164.164 0 0 0-.06-.126 5.466 5.466 0 0 1-1.94-4.182V6.667A3.67 3.67 0 0 0 7.99 3Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#434242",
      d: "M7.99 3a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 1 0v2a.5.5 0 0 1-.5.5Z"
    }, null, -1)
  ])))
}
export default { render: render }